import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import { validate, renderParticipantField, isDebug, renderField } from './helpers'
import { AdditionalParticipantsValidation } from '../../helpers/step-builder/validations-yup'
import { CustomerWaiverSchemas } from 'polaris-adventures-js'

function AdditionalParticipantsFunc({
  // eslint-disable-next-line react/prop-types
  payload,
  // eslint-disable-next-line react/prop-types
  setPayload,
  // eslint-disable-next-line react/prop-types
  prevStep,
  // eslint-disable-next-line react/prop-types
  nextStep,
  // eslint-disable-next-line react/prop-types
  isGuest,
  // eslint-disable-next-line react/prop-types
  isEhs,
  // eslint-disable-next-line react/prop-types
  productLine,
  // eslint-disable-next-line react/prop-types
  queryParams,
  // eslint-disable-next-line react/prop-types
  waiverParticipantsModel,
  // eslint-disable-next-line react/prop-types
  t
}) {
  const [errors, setErrors] = useState({})
  const [additionalParticipants, setAdditionalParticipants] = useState(payload.participants)

  // eslint-disable-next-line react/prop-types
  const participants = waiverParticipantsModel && waiverParticipantsModel.participants
  const hd = {
    errors,
    payload,
    setPayload,
    participants,
    t
  }
  setDebugPayload()

  const isEhsRequired = !(
    waiverParticipantsModel &&
    // eslint-disable-next-line react/prop-types
    waiverParticipantsModel.minorParticipantsCheckbox &&
    // eslint-disable-next-line react/prop-types
    waiverParticipantsModel.minorParticipantsCheckbox.hidden
  )
  const validation = AdditionalParticipantsValidation(isGuest, productLine, payload, participants, isEhsRequired, t)

  useEffect(() => {
    setPayload({
      ...payload,
      isGuest: !!isGuest,
      isEhsRequired
    })
    setAdditionalParticipants(payload.participants)
  }, [isGuest, isEhsRequired, payload.participants])

  const nextStepClick = async () => {
    const _errors = await validate(validation, payload)
    if (Object.keys(_errors).length === 0) {
      nextStep()
    }
    setErrors(_errors)
  }

  const addAnotherGuest = () => {
    const newParticipant = { firstName: '', lastName: '', isUnder18: isEhs ? undefined : false }
    setAdditionalParticipants([...additionalParticipants, newParticipant])
    setPayload({ ...payload, participants: [...payload.participants, newParticipant] })
  }

  const buttonFunctions = { nextStepClick, prevStep }
  return (
    <>
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverParticipantsModel.minorParticipantsCheckbox)
      }
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverParticipantsModel.minorParticipantsAccompaniedCheckbox)
      }
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverParticipantsModel.minorParticipantsNotDriveCheckbox)
      }
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverParticipantsModel.minorParticipantsPassengersCheckbox)
      }
      {
        // eslint-disable-next-line react/prop-types
        renderField(hd, waiverParticipantsModel.minorParticipantsBySignCheckbox)
      }
      <div>
        {
          // eslint-disable-next-line react/prop-types
          additionalParticipants &&
            // eslint-disable-next-line react/prop-types
            additionalParticipants.map((participant, ix) => (
              <div className="flex flex-top" key={ix}>
                {renderParticipantField(hd, 'firstName', ix, ...Array(2), false, undefined, participant.firstName)}
                {renderParticipantField(hd, 'lastName', ix, ...Array(2), false, undefined, participant.lastName)}
                {renderParticipantField(
                  hd,
                  'isUnder18',
                  ix,
                  t('under18'),
                  undefined,
                  true,
                  participant['firstName'],
                  participant.isUnder18
                )}
              </div>
            ))
        }
      </div>

      <div className="right">
        {waiverParticipantsModel &&
          // eslint-disable-next-line react/prop-types
          waiverParticipantsModel.buttons.map((button, ix) => (
            <>
              <Button
                variant={button.variant}
                color={button.color}
                size={button.size}
                className={button.className}
                onClick={buttonFunctions[button.clickFunc]}
                id={
                  // eslint-disable-next-line react/prop-types
                  waiverParticipantsModel.label + '-' + button.label + '-' + ix.toString()
                }
                key={
                  // eslint-disable-next-line react/prop-types
                  waiverParticipantsModel.label + '-' + button.label + '-' + ix.toString()
                }
              >
                {t(button.label)}
              </Button>
            </>
          ))}
      </div>
      <div className="right mt-1">
        <Button
          disabled={additionalParticipants.length >= CustomerWaiverSchemas.ADDITIONAL_RIDERS_LIMIT}
          onClick={addAnotherGuest}
        >
          {t('addAnotherGuest')}
        </Button>
      </div>
    </>
  )

  function setDebugPayload() {
    // eslint-disable-next-line react/prop-types
    if (isDebug() && payload.participants && payload.participants.length && !payload.participants[0].firstName) {
      // eslint-disable-next-line react/prop-types
      payload.participants[0] = { firstName: 'John', lastName: 'Dow', isUnder18: true }
      // eslint-disable-next-line react/prop-types
      payload.participants[1] = { firstName: 'Peter', lastName: 'Tosh', isUnder18: false }
      setPayload({ ...payload })
    }
  }
}

export const AdditionalParticipants = withTranslation()(AdditionalParticipantsFunc)
